<div *ngIf="(page$ | async) as page" class="container col-11 col-md-8 col-lg-7 col-xl-6 col-xxl-5 py-lg-4 py-md-4 py-sm-3 py-2 page-container">

    <div class="row">
        <h1 class="page-title">{{page.Title}}</h1>
    </div>
    <div class="row justify-content-between pb-3 pt-1 align-items-baseline">
        <div *ngIf="page.PublishingDate as publishingDate; else draft" class="small"><span i18n="@@page-published-text">Publishing date</span>: {{publishingDate|date}}</div>
        <ng-template #draft>
            <div class="small"><span i18n="@@page-published-text">Publishing date</span>: <span i18n="@@page-draft-text" class="font-italic">Draft</span></div>
        </ng-template>
        <div *ngIf="showEditMode$ | async" class="d-print-none">
            <a class="action small" [routerLink]="['./edit']" i18n="@@page-edit-text"><i class="fa fa-pencil mr-1" aria-hidden="true"></i>Edit page</a>
        </div>
    </div>
    <div class="row pb-3" *ngIf="page.BannerImageUrl">
        <div class="page-banner-image-container">
            <img src="{{page.BannerImageUrl}}" alt="{{page.BannerImageAltText}}" class="page-banner-image" />
        </div>
    </div>
    <div class="row pb-1 small justify-content-end" *ngIf="page.BannerImageUrl && page.BannerImageText">
        <span class="font-italic">{{ page.BannerImageText }}</span>
    </div>

    <div class="row py-2 page-content">
        <div [innerHTML]="page.Content"></div>
    </div>

    <div class="row py-2 justify-content-between">
        <div class="d-flex" *ngIf="modifiedByUser$ | async as modifiedByUser">
            <div class="pt-1 pr-2">
                <ng-container *ngIf="page.ModifiedByUserPhotoUrl$ | async as src;else tempImg">
                    <img class="rounded-circle mr-2 page-user-img" [attr.src]="src | safe: 'url'" alt="" />
                </ng-container>
                <ng-template #tempImg>
                    <div class="bg-subtle-color rounded-circle mr-2 page-user-img d-flex justify-content-center align-items-center"
                         title="{{modifiedByUser.Name}}">
                        <span>{{ getPreferredNameLetters(modifiedByUser.UPN)}}</span>
                    </div>
                </ng-template>
            </div>
            <div>
                <span class="small mt-1 d-block">{{modifiedByUser.Name}}</span>
                <span class="text-muted small pb-1 d-block">
                    <span i18n="@@page-edited-text">Edited</span> {{page.Modified|date}}
                </span>
            </div>
        </div>
        <div class="d-flex" *ngIf="ownerUser$ | async as ownerUser">
            <div class="pt-1 pr-2">
                <ng-container *ngIf="page.OwnerPhotoUrl$ | async as src;else tempImg">
                    <img class="rounded-circle mr-2 page-user-img" [attr.src]="src | safe: 'url'" alt="" />
                </ng-container>
                <ng-template #tempImg>
                    <div class="bg-subtle-color rounded-circle mr-2 page-user-img d-flex justify-content-center align-items-center"
                         title="{{ownerUser.Name}}">
                        <span>{{ getPreferredNameLetters(ownerUser.UPN)}}</span>
                    </div>
                </ng-template>
            </div>
            <div>
                <span class="small mt-1 d-block">{{ownerUser.Name}}</span>
                <span class="text-muted small pb-1 d-block">
                    <span i18n="@@page-information-owner-text">Information owner</span>
                </span>
            </div>
        </div>
    </div>
    <div class="row py-3 mt-2 border-top border-light">
        <mat-chip-list>
            <ng-container *ngIf="language$ | async as language">
                <mat-chip [value]="page.LanguageTermId" [selectable]="false">
                    <span class="small">{{language}}</span>
                </mat-chip>
            </ng-container>
            <mat-chip *ngFor="let channel of selectedChannels$ | async" [value]="channel.Guid" [selectable]="false">
                <span class="small">{{channel.Name}}</span>
            </mat-chip>
        </mat-chip-list>
    </div>
    <div class="row py-3 mt-2 border-top border-light" *ngIf="page.IsCommentsEnabled">
        <app-commento [dataPageId]="getCommentoPageId(page)"></app-commento>
    </div>
</div>
